import React from 'react';
import SanityImage from 'gatsby-plugin-sanity-image';
import {
  AspectRatio,
  Box,
  chakra,
  shouldForwardProp,
  Text,
  usePrefersReducedMotion,
} from '@chakra-ui/react';
import { motion, isValidMotionProp } from 'framer-motion';
import { withPrefix } from 'gatsby';

const AnimatedBox = chakra(motion.div, {
  shouldForwardProp: (prop) => isValidMotionProp(prop) || shouldForwardProp(prop),
});

const AnimatedRevealBox = chakra(motion.div, {
  shouldForwardProp: (prop) => isValidMotionProp(prop) || shouldForwardProp(prop),
});

const AnimatedLocationBox = chakra(motion.figcaption, {
  shouldForwardProp: (prop) => isValidMotionProp(prop) || shouldForwardProp(prop),
});

function Hero({ data }) {
  const prefersReducedMotion = usePrefersReducedMotion();
  const { image, useVideo, location, slug } = data || {};

  return (
    <Box as='section' position='sticky' top={{ base: '4.375rem', xl: '5.5rem' }}>
      <figure>
        {image && (
          <AspectRatio ratio={2.5} overflow='hidden'>
            <AnimatedBox
              animate={{
                opacity: [0, 1],
                transform: ['scale(1.1)', 'scale(1)'],
              }}
              transition={{
                duration: 2,
                ease: 'easeInOut',
                delay: 1,
              }}
            >
              {useVideo && !prefersReducedMotion ? (
                <Box
                  as='video'
                  autoPlay
                  loop
                  muted
                  playsInline
                  width='100%'
                  height='100%'
                  objectFit='cover'
                >
                  <source src={`${withPrefix('/')}${slug.current}.mp4`} type='video/mp4' />
                </Box>
              ) : (
                <SanityImage
                  {...image}
                  alt={image?.asset?.altText}
                  width={1200}
                  height={800}
                  hotspot={image?.hotspot}
                  crop={image?.crop}
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                  }}
                />
              )}
            </AnimatedBox>
          </AspectRatio>
        )}
        {image && (
          <AnimatedRevealBox
            animate={{
              transform: ['scaleX(0)', 'scaleX(1)', 'scaleX(1)', 'scaleX(0)'],
              transformOrigin: ['0% 50%', '0% 50%', '100% 50%', '100% 50%'],
            }}
            transition={{
              duration: 2,
              ease: 'easeInOut',
            }}
            position='absolute'
            top='0'
            left='0'
            right='0'
            bottom='0'
            zIndex='1'
            background='navy'
          />
        )}
        {location && (
          <AnimatedLocationBox
            animate={{
              opacity: [0, 1],
            }}
            transition={{
              duration: 2,
              ease: 'easeInOut',
              delay: 1,
            }}
            position='absolute'
            top='10'
            right='20'
            padding={5}
            background='rgba(0,0,0,.5)'
          >
            <Text color='white' fontSize='sm'>
              {location}
            </Text>
          </AnimatedLocationBox>
        )}
      </figure>
    </Box>
  );
}

export default Hero;
